/* unplugin-vue-components disabled */import script from "./awardsCertificationBanner.vue?vue&type=script&lang=js"
export * from "./awardsCertificationBanner.vue?vue&type=script&lang=js"

import "./awardsCertificationBanner.vue?vue&type=style&index=0&id=6e63e21d&lang=scss"

const __exports__ = script;

export default __exports__